<template>
  <div class="row" id="news-detail-panel">
    <messageModal v-if="showMessage" message="votre news a été crée !" @closeMessage="goToDetail"></messageModal>
        <div class="row columns">
            <br>
            <div class="row cloumns news-league large-centered">
                1/ Choisissez la ligue que l'article concerne ou laissez vide pour un article général :
                <hr>
            </div>
            <div class="row cloumns">
                <div class="large-3 large-centered columns">
                    <select v-model="selectedClub">
                        <option v-for="club in clubList" v-bind:value="club.id">
                            {{ club.name }}
                        </option>
                    </select>
                </div>
            </div>
        </div>
            <div class="row cloumns news-league large-centered">
                2/ puis éditez le texte et les images de votre article
                <hr>
            </div>
        <div class="detailed-news-panel">
            <div class="detailed-news-panel-title">
                <div class="row columns">
                    <div class="medium-9 columns">
                        <p id="tit" contenteditable="true">Titre du nouvel article, cliquez moi !</p>
                    </div>
                    <div class="medium-3 columns">
                        <div class="detailed-news-actions">
                            <button :disabled="selectedClub===null" @click="createContent">Créer</button>
                        </div>
                    </div>
                </div>
                <hr>
                </div>
                <div id="post_content" class="panel-content">
                    <div class="row columns">
                        <div class="large-5 columns">
                            <imageEditor ref="imgEditor" :imageSrc="'http://via.placeholder.com/350x300'"></imageEditor>
                        </div>
                        <div id="par1" class="large-7 columns" style="text-align:justify" contenteditable="true">
                        <h3>Bienvenue sur la page de création d'un nouvel article !</h3>
                        Vous pouvez éditer directement le contenu de la page, juste en cliquant dans
                        les zones qui vous intéressent, le titre, la photo, les paragraphes etc....
                        Lorsque vous vous avez finit votre bafouille, vous avez juste à cliquer sur le
                        bouton "créer" en haut à droite, et pis c'est tout. Votre news sera directement
                        publiée. Mais pas de panique vous pourrez toujours la modifier ensuite. Allez bonne frappe !
                        </div>
                    </div>
                    <br>
                    <div class="row columns" style="text-align:justify">
                        <div id="par2" class="large-12 columns" contenteditable="true">
                        <h3>Deuxième paragraphe</h3>
                        Là aussi vous pouvez cliquer, et éditer. Si vous ne voulez pas de deuxième paragraphe, et ben virez le contenu !

                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam leo augue, fermentum a lacus scelerisque, auctor lacinia augue. Sed et nibh magna. Fusce enim ante, porttitor ac metus ut, interdum posuere felis. Etiam sit amet pretium mauris. Pellentesque a tincidunt purus, eu elementum sapien. Suspendisse gravida leo a purus tincidunt tempus. Suspendisse quis est non ex facilisis elementum.
                        Duis lacus elit, dapibus nec massa vel, porta convallis ligula. Etiam sed rhoncus nunc. Nulla non vehicula mauris, non dignissim risus. Maecenas auctor tellus sit amet nulla suscipit bibendum. Pellentesque at lacus sit amet nisi euismod pharetra. Morbi lobortis pulvinar vehicula. Maecenas sed lobortis risus. Integer rutrum maximus erat, sed vestibulum lorem.
                        </div>
                    </div>
                </div>
            </div>
            <button :disabled="selectedClub===null" @click="createContent">Créer</button>
        </div>
    </div>
</template>

<script>
import imageEditor from '../common/image-editor.vue'
import messageModal from '../common/message-modal.vue'
import { mapGetters } from 'vuex'
import Vue from 'vue'
import news from '../../api/news.api'
import store from '../../store/index.js'

export default {
  name: 'newsCreate',
  components: {
    imageEditor,
    messageModal
  },
  data () {
    return {
      par1: '',
      par2: '',
      id: 0,
      showMessage: false,
      selectedClub: null
    }
  },
  computed:
  {
    ...mapGetters([
      'currentUser',
      'clubList'
    ])
  },
  methods: {
    initContent () {
      Vue.nextTick(tick => {
        // quand le chargement claque, on initialise CKeditor
        this.activateEditor()
      })
    },
    activateEditor () {
      if (!window.CKEDITOR) {
        console.error('Please include CKEditor in your page')
        return
      }
      window.CKEDITOR.disableAutoInline = true
      window.CKEDITOR.inline('tit')
      window.CKEDITOR.inline('par1')
      window.CKEDITOR.inline('par2')
    },
    goToDetail () {
      this.showMessage = false
      this.$router.push({name: 'NewsDetail', params: { id: this.id }})
    },
    createContent () {
      let createdPost = {}
      createdPost.featured_club = this.selectedClub
      createdPost.title = this.$el.querySelector('#tit').innerHTML
      createdPost.description = this.$el.querySelector('#par1').innerText.substring(0, 50)
      createdPost.status = 2
      createdPost.publish_date = new Date()
      createdPost.expiry_date = null
      createdPost.content = this.$el.querySelector('#post_content').innerHTML
      createdPost.allow_comments = true
      createdPost.featured_image = this.$refs.imgEditor.currentImageSrc
      createdPost.user = this.currentUser.id
      console.log(createdPost)

      news.api.createNews(createdPost)
      .then(response => {
        this.showMessage = true
        this.id = response.data['id']
      },
      error => {
        console.log('impossible to update news')
        console.log(error)
      })
    }
  },
  created () {
    store.dispatch('hideLeaguePanel')
    store.dispatch('deactivateFullSizePage')
  },
  mounted () {
    this.initContent()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.detailed-news-panel  {
    background-color: rgba(255,255,255,0.9);
    border-width: 1px;
    border-style: solid;
    border-color: #E1E5EC;
    padding: 0rem;
    margin: 1rem 0rem 1rem 0rem;
    box-shadow: 0 1px 3px rgba(0,0,0,0.12),0 1px 2px rgba(0,0,0,0.24);
}

.detailed-news-panel-title {
    width: 100%;
    text-align: left;
    font-weight: 300;
    font-size: 2rem;
    padding: 1.4rem 1.4rem 0rem 1.3rem;
}

.news-league {
    font-size: 1.3rem;
    font-weight: 300;
    text-align: left;
}
</style>



// WEBPACK FOOTER //
// news-create.vue?cf04b644